// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.numeric-input-widget-body > table {
    width: 100%;
}

div.numeric-input-widget-body > table td {
    padding: 1px 0;
}

div.numeric-input-widget-body > table input {
    width: 100%;
}

div.numeric-input-widget-body > table tr:hover {
    background-color: var(--list-item-bg-color-hover);
}

div.numeric-input-widget-body > table td:not(:has(> div.TextInput)) {
    width: 1%;
}

div.numeric-input-widget-body > table td:not(:has(> div.TextInput)):not(:first-child) {
    padding-left: 2px;
}

div.numeric-input-widget-body > table td > span {
    display: inline-flex;
    width: 100%;
    border: 1px solid var(--border-color);
    border-right-width: 0;
    height: 2em;
    align-items: center;
    padding: 0 0.25em;
}`, "",{"version":3,"sources":["webpack://./components/style/NumericInputWindow.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,qCAAqC;IACrC,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":["div.numeric-input-widget-body > table {\n    width: 100%;\n}\n\ndiv.numeric-input-widget-body > table td {\n    padding: 1px 0;\n}\n\ndiv.numeric-input-widget-body > table input {\n    width: 100%;\n}\n\ndiv.numeric-input-widget-body > table tr:hover {\n    background-color: var(--list-item-bg-color-hover);\n}\n\ndiv.numeric-input-widget-body > table td:not(:has(> div.TextInput)) {\n    width: 1%;\n}\n\ndiv.numeric-input-widget-body > table td:not(:has(> div.TextInput)):not(:first-child) {\n    padding-left: 2px;\n}\n\ndiv.numeric-input-widget-body > table td > span {\n    display: inline-flex;\n    width: 100%;\n    border: 1px solid var(--border-color);\n    border-right-width: 0;\n    height: 2em;\n    align-items: center;\n    padding: 0 0.25em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
